import alt from '../alt';


class CertificateActions {
    constructor() {
        this.generateActions('getCertificatesSuccess');
    }

}

export default alt.createActions(CertificateActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/CertificateActions.js
 **/